import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonValues } from 'src/app/services/commonValues';
import { Subscription } from 'rxjs';
import { GlobalCommunity } from '../../../services/globalCommunity.service';
import { WidgetModule } from '../../../widget/widget.module';
import { TruncatePipe } from '../../../pipe/TruncatePipe.pipe';
import { NavheadercommunityComponent } from '../navheadercommunity/navheadercommunity.component';
import { BussinessPostComponent } from '../../bussiness-post/bussiness-post.component';
import { CommunityProfileComponent } from '../community-profile/community-profile.component';
import { CommunityPageadminComponent } from '../community-pageadmin/community-pageadmin.component';
import { BusinessEmployeeComponent } from '../../bussinesspages/business-employee/business-employee.component';
import { MembersComponent } from '../members/members.component';
import { RequestComponent } from '../request/request.component';
import { InvitesendComponent } from '../invitesend/invitesend.component';
import { BusinessAnalyticsComponent } from '../../bussinesspages/business-analytics/business-analytics.component';
import { CommunityBannerComponent } from '../community-banner/community-banner.component';
import { ManagepageComponent } from '../managepage/managepage.component';
import { DeactivateCommunityComponent } from '../deactivate-community/deactivate-community.component';

@Component({
  selector: 'app-community',
  standalone: true,
  imports: [
    CommonModule,
    WidgetModule,
    TruncatePipe,
    NavheadercommunityComponent,
    BussinessPostComponent,
    CommunityProfileComponent,
    CommunityPageadminComponent,
    BusinessEmployeeComponent,
    MembersComponent,
    RequestComponent,
    InvitesendComponent,
    BusinessAnalyticsComponent,
    CommunityBannerComponent,
    ManagepageComponent,
    DeactivateCommunityComponent
  ],
  templateUrl: './community.component.html',
  styleUrls: ['./community.component.scss']
})
export class CommunityComponent implements OnInit {
  home: Boolean = true
  about: Boolean = true
  clickEventsubscription: Subscription;
  communityData: any = {}
  menu = 'communityhome'
  passdata: any[];
  userType="ALL"
  adminWidgets: any;

  constructor(private commonvalues: CommonValues , public globalCommunity : GlobalCommunity) {
    this.clickEventsubscription = this.commonvalues.getbusinessid().subscribe((res) => {
     // //// console.log(res)
      this.communityData = res;
      if (this.communityData.menu && this.communityData.menu !== this.menu) {
        this.menu = this.communityData.menu;
        // Menu switch (Home/About/Members/...) swaps the visible child view
        // via *ngIf in place — there's no route change to trigger the app's
        // scroll reset, so do it explicitly here.
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

    })
  }

  ngOnInit() {

    window.scrollTo(0, 0);
  }


  addTodo(commondata) {
    this.passdata = commondata; 

     this.adminWidgets = commondata.adminviewnavigation;
     if(!commondata.isSuperAdmin && !commondata.admin){
     this.userType="ALL";
    } else{
     this.userType="ADMIN";

    if(commondata.communityType==false ){
      this.adminWidgets = true;
    }


    }


   }

   businesBannerData : any;
   updateFunction(data:any){
    this.businesBannerData = data;
   }

}

